import type { RespostaWms } from "../../lib/rpc";
import type { Tom } from "../../componentes/ui";

export type StatusDevolucao = "aguardando" | "em_conferencia" | "finalizada" | "cancelada";
export type Condicao = "BOM" | "AVARIADO" | "DEFEITO";
export type OrigemDevolucao = "CLIENTE" | "FULL" | "TRANSPORTADORA";

export const nomeStatusDevolucao: Record<StatusDevolucao, string> = {
  aguardando: "Aguardando chegada",
  em_conferencia: "Em conferência",
  finalizada: "Finalizada",
  cancelada: "Cancelada",
};

export const tomStatusDevolucao: Record<StatusDevolucao, Tom> = {
  aguardando: "info",
  em_conferencia: "faixa",
  finalizada: "ok",
  cancelada: "neutro",
};

export const nomeCondicao: Record<Condicao, string> = { BOM: "Bom", AVARIADO: "Avariado", DEFEITO: "Defeito" };
export const tomCondicao: Record<Condicao, Tom> = { BOM: "ok", AVARIADO: "alerta", DEFEITO: "erro" };
export const textoCondicao: Record<Condicao, string> = {
  BOM: "Volta para o estoque depois da quarentena",
  AVARIADO: "Dano de transporte ou uso: vai para o defeito",
  DEFEITO: "Defeito de fabricação: vai para o defeito",
};

export const nomeOrigemDevolucao: Record<OrigemDevolucao, string> = {
  CLIENTE: "Cliente",
  FULL: "Mercado Livre Full",
  TRANSPORTADORA: "Transportadora",
};

export const nomeNfStatus: Record<string, string> = {
  nao_emitir: "Sem NF de devolução",
  pendente: "NF na fila do Tiny",
  criada: "NF criada no Tiny",
  emitida: "NF emitida (SEFAZ)",
  cliente_emite: "Cliente emite a NF",
  erro: "Erro na NF",
};
export const tomNfStatus: Record<string, Tom> = {
  nao_emitir: "neutro", pendente: "info", criada: "ok", emitida: "ok", cliente_emite: "alerta", erro: "erro",
};

/** Sugestões de motivo (o CX pode escrever outro). */
export const MOTIVOS = [
  "Arrependimento (7 dias)",
  "Avaria no transporte",
  "Defeito de fabricação",
  "Peça faltando",
  "Produto errado",
  "Recusado na entrega",
  "Endereço não encontrado",
  "Troca",
];

/** Linha da view v_devolucoes. */
export interface LinhaDevolucao {
  id: string;
  numero: number;
  deposito_id: string;
  origem: OrigemDevolucao;
  status: StatusDevolucao;
  motivo: string;
  codigo_rastreio: string | null;
  peso_kg: number | null;
  criado_em: string;
  recebida_em: string | null;
  finalizada_em: string | null;
  nf_status: string;
  nf_numero: string | null;
  pedido: string | null;
  numero_ecommerce: string | null;
  canal: string | null;
  criado_por: string | null;
  itens_bons: number;
  itens_avariados: number;
  /** NF de venda, quando a devolução foi aberta pela nota do Tiny (pedido fora do WMS) */
  nota_venda?: string | null;
}

/** Nota de venda lida no Tiny (tiny-notas com "venda"): sem dados do cliente. */
export interface NotaVendaTiny {
  tiny_id: number;
  numero: string | null;
  serie: string | null;
  chave: string | null;
  emitida_em: string | null;
  pedido_numero: string | null;
  itens: Array<{ numero_item: number; codigo: string | null; descricao: string | null; unidade: string | null;
                 gtin: string | null; quantidade: number; valor_unitario: number | null }>;
}

export interface ItemRecebido {
  id: string;
  produto_id: string;
  sku: string | null;
  nome: string;
  condicao: Condicao;
  quantidade: number;
  observacao: string | null;
  destino: string | null;
}

export interface ResumoDevolucao extends RespostaWms {
  devolucao: {
    id: string;
    numero: number;
    origem: OrigemDevolucao;
    status: StatusDevolucao;
    motivo: string;
    codigo_rastreio: string | null;
    peso_kg: number | null;
    observacao: string | null;
    observacao_recebimento: string | null;
    pedido_numero: string | null;
    deposito_id: string;
    criado_em: string;
    recebida_em: string | null;
    finalizada_em: string | null;
    criado_por: string | null;
    recebida_por: string | null;
    finalizada_por: string | null;
    nf_status: string;
    nf_numero: string | null;
    nf_erro: string | null;
    nota_chave?: string | null;
    /** NF de venda lida no Tiny (pedido fora do WMS) */
    venda_nota_numero?: string | null;
    venda_nota_serie?: string | null;
  };
  pedido: {
    id: string;
    numero: number;
    numero_ecommerce: string | null;
    canal: string | null;
    nota: string | null;
    status: string;
    forma_envio: string | null;
    expedido_em: string | null;
  } | null;
  esperado: Array<{ produto_id: string; sku: string | null; nome: string; quantidade: number }>;
  recebido: ItemRecebido[];
  itens_venda: Array<{ pedido_item_id: string; sku: string | null; descricao: string; vendido: number; devolvido: number; valor_unitario: number | null }>;
  /** Itens da nota de venda do Tiny, quando o pedido não está no WMS */
  itens_nota?: Array<{ id: string; codigo: string | null; descricao: string | null; quantidade: number; valor_unitario: number | null; sku: string | null; ligado: boolean }>;
}

/** Item vendido devolvido pelo histórico do pedido (wms_pedido_historico). */
export interface ItemVendido { pedido_item_id: string; sku: string | null; nome: string; quantidade: number; valor_unitario: number | null }
